import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=16de195a&scoped=true&"
import script from "./Attestation.vue?vue&type=script&lang=js&"
export * from "./Attestation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de195a",
  null
  
)

export default component.exports